export default "__VITE_ASSET__zOes0KJF__"